<template src="./html/Products.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import Vuetable from 'vuetable-2/src/components/Vuetable'
	import VuetablePaginationInfo from 'vuetable-2/src/components/VuetablePaginationInfo'
	import VuetablePagination from 'vuetable-2/src/components/VuetablePagination'
	import FilterBar from './FilterBar'
	import VueElementLoading from 'vue-element-loading'
	export default {
		props: ['user', 'isAuth', 'item', 'type'],
		components: {
			'datatable': Vuetable,
			'pagination-info': VuetablePaginationInfo,
			'pagination': VuetablePagination,
			'filter-bar': FilterBar,
			'loading': VueElementLoading,
		},
		data () {
			return {
				modal: {
					selector: 'modal-products'
				},
				products: null,
				perPages: [
					{
						label: 20,
						value: 20,
					},
					{
						label: 50,
						value: 50,
					},
					{
						label: 100,
						value: 100,
					},
					{
						label: 'Todo',
						value: null,
					},
				],
				datatable: {
					api: this.$env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/products/datatable',
					loading: true,
					moreParams: {
						filter: {
							allowDate: false,
							date: null,
							text: null,
							currency_id: null,
							has_tax: null,
							tax_id: null,
							category_id: null,
						}
					},
					page: 20,
					path: '',
					sortOrder: [
						{
							field: 'created_at',
							sortField: 'created_at',
							direction: 'desc',
						}
					],
					options: {
						headers: {
							'Authorization': 'Bearer ' + this.$auth.getToken()
						}
					},
					css: {
						table: {
							sortableIcon: 'fa fa-sort',
							tableClass: 'table table-hover table-striped table-condensed',
							ascendingIcon: 'fa fa-caret-up',
							descendingIcon: 'fa fa-caret-down',
						},
						pagination: {
							wrapperClass: "pagination pull-right",
							activeClass: "btn-default disabled",
							disabledClass: "disabled",
							pageClass: "btn btn-default",
							linkClass: "btn btn-default",
							icons: {
								first: "fa fa-fast-backward",
								prev: "fa fa-step-backward",
								next: "fa fa-step-forward",
								last: "fa fa-fast-forward",
							}
						},
					},
					fields: [
						{
							name: 'id',
							title: this.$platform.setting.number_symbol,
							sortField: 'id',
						},
						{
							name: 'reference',
							title: 'Ref.',
							sortField: 'reference',
						},
						{
							name: 'title',
							title: 'Título',
							sortField: 'title',
						},
						{
							name: 'total',
							title: 'Precio',
						},
						{
							name: '__slot:actions',
							title: '',
						},
					],
				},
			}
		},
		watch: {
			item() {
				this.datatable.moreParams.filter.currency_id = this.item.currency_id
				if(this.item.provider) {
					this.datatable.moreParams.filter.provider_id = this.item.provider.id
				}
				if(this.item.tax_id) {
					this.datatable.moreParams.filter.has_tax = false
				} else {
					this.datatable.moreParams.filter.has_tax = true
					this.datatable.moreParams.filter.tax_id = this.item.tax_id
				}
				this.reload()
			},
		},
		mounted() {
			var modal = $('#'+this.modal.selector)
			var that = this
			modal.on('hidden.bs.modal', function () {
				that.filterReset()
			})

			this.$events.$on('filterSet', eventData => this.filterSet(eventData))
			this.$events.$on('filterReset', eventData => this.filterReset(eventData))
		},
		methods: {
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
				this.$refs.filterBar.$refs.inputSearch.focus()
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			add (product) {
				var that = this
				var ref = '#btnAdd-' + product.id
				var loading = Ladda.create(document.querySelector(ref))
				loading.start()
				var data = {
					product_id: product.id
				}
				if(this.type == 'budget') {
					data.budget_id = this.item.id
					if(this.item.order) {
						data.order_id = this.item.order.id
					}
					if(this.item.invoice) {
						data.invoice_id = this.item.invoice.id
					}
				}
				if(this.type == 'order') {
					if(this.item.customer) {
						data.order_id = this.item.id
						if(this.item.invoice) {
							data.invoice_id = this.item.invoice.id
						}
						if(this.item.invoice) {
							data.invoice_id = this.item.invoice.id
						}
						if(this.item.invoice_multiple) {
							data.invoice_id = this.item.invoice_multiple.id
						}
					}
					if(this.item.provider) {
						data.order_provider_id = this.item.id
						if(this.item.invoice) {
							data.invoice_provider_id = this.item.invoice.id
						}
					}
				}
				if(this.type == 'invoice') {
					if(this.item.provider) {
						data.invoice_provider_id = this.item.id
					} else {
						data.invoice_id = this.item.id
					}
				}
				if(this.type == 'agreement') {
					data.agreement_id = this.item.id
				}
				this.$http.post('admin/management/products/storages', data)
				.then(response => {
					loading.stop()
					this.$emit('reload')
					this.editOrcontinue(response)
				}).catch(function(response) {
					loading.stop()
					console.log(response)
				})
			},
			editOrcontinue(response) {
				var that = this
				swal({
					title: response.body.title,
					text: response.body.text,
					type: response.body.type,
					showCancelButton: true,
					confirmButtonColor: '#2cabe3',
					confirmButtonText: 'Editar',
					cancelButtonText: 'Continuar',
				}).then(function () {
					that.closeAndEdit(response.body.data)
				}).catch(function(response) {
					//console.log(response)
				})
			},
			closeAndEdit(data) {
				this.close()
				this.$emit('editProduct', data)
			},
			reload() {
				this.$nextTick( () => this.$refs.datatable.refresh())
			},
			loading() {
				this.datatable.loading = true
			},
			loaded() {
				this.datatable.loading = false
			},
			onPaginationData (paginationData) {
				this.$refs.paginationInfo.setPaginationData(paginationData)
				this.$refs.pagination.setPaginationData(paginationData)
			},
			onChangePage (page) {
				this.$refs.datatable.changePage(page)
			},
			filterSet: _.debounce(function () {
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			}, 300),
			filterReset() {
				this.clearFilter()
				if(this.$refs.datatable) {
					this.$nextTick( () => this.$refs.datatable.refresh())
				}
			},
			clearFilter() {
				this.datatable.moreParams.filter.text = null
				this.datatable.moreParams.filter.category_id = null
			},
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productStorages/views/Products.vue